<template>
  <div>
    <div  class="basic-margin cd-title-label"><b>渠道列表</b>
      <el-col style="cursor:pointer;padding-left:77px;margin-top:-22px;">
        <el-tooltip placement="top" >
        <div slot="content">
          以下列表展示渠道渠道上该项目的运营情况。（均为截止昨日数据，每晚0点更新）<br/><br/>
          累计页面PV：指频道页自开通以来累计访问量<br/><br/>
          累计访问UV：指频道页自开通以来累计访问人数<br/><br/>
          累计线索量：指通过频道页自开通以来累计收集的线索条数<br/><br/>
          累计线索收入：指频道页自开通以来累计收集的线索成功转化成收益的金额<br/><br/>
          累计线索被评：指频道页自开通以来累计收集的线索被合伙人查看后进行评价的结果统计
          </div>
          <span class="el-icon-information" ></span>
        </el-tooltip>
      </el-col>

    </div>
  <el-table
    :data="data"
    border
    style="width: 100%"
    >
    <el-table-column
      prop="channelName"
      label="渠道名称"
      >
    </el-table-column>
    <el-table-column
      prop="pvCount"
      label="累计页面PV">
    </el-table-column>
    <el-table-column
      prop="uvCount"
      label="累计访问UV">
    </el-table-column>
    <el-table-column
      prop="clueCount"
      label="累计线索量">
    </el-table-column>
    <el-table-column
      prop="effectClueCount
      label="累计有效线索量">
    </el-table-column>
    <el-table-column
      prop="clueIncome"
      label="累计线索收入">
    </el-table-column>
    <el-table-column
    :width=350
      label="累计线索被评">
      <template scope="scope">
        <p>  <el-rate
            disabled
              v-model="highPraise" :max=3 text-color="#ff9900"
              :text-template=scope.row.goodCountString
              show-text>
          </el-rate></p>
      </p><el-rate
        disabled
          v-model="middlePraise" :max=3 text-color="#ff9900"
          :text-template=scope.row.commonCountString
          show-text>
      </el-rate>
      </p>
      <p>
        <el-rate
          disabled
            v-model="lowPraise" :max=3 text-color="#ff9900"
            :text-template=scope.row.badCountString
            show-text>
        </el-rate>
      </p>
        <span style="margin-left: 10px">{{ scope.row.date }}</span>
      </template>
    </el-table-column>

  </el-table>
  <el-pagination
  class="row basic-margin"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
</div>
</template>
<style media="screen" >
  .el-table .info-row {
    background: #c9e5f5;
  }
  .el-table .positive-row {
    background: #e2f0e4;
  }
  .cd-title-label{
    margin-top: 25px;
    color: rgb(32, 160, 255);
    font-size: 17px;
    margin-bottom: 10px;
  }
</style>
<script>
import DataMonitorModel from '../../../framework/models/dataMonitorModel'
import BasicPager from '../../../mixins/BasicPager'
export default {
  name: 'clue-data-monitor-channel',
  extends: BasicPager,
  data: function () {
    return {
      data: [
      ],
      currentPage: 1, // 起始
      pageSize: 5, // 步长
      totalCount: 0, // 总条数
      highPraise: 3,
      middlePraise: 2,
      lowPraise: 1
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    handleSizeChange (val) { // 监听页数变化
      this.pageSize = val
      this.loadList()
    },
    handleCurrentChange (val) { // 监听页码变化
      this.currentPage = val
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        currentPage: _this.currentPage,
        pageSize: _this.pageSize
      }
      let listener = {
        success: function (dataInfo) {
          for (var i = 0; i < dataInfo.data.length; i++) {
            let count = dataInfo.data[i].goodCount + dataInfo.data[i].commonCount + dataInfo.data[i].badCount
            if (count == 0) {
              dataInfo.data[i].goodCountString = ' 好评' + 0 + '个，' + '好评率' + 0 + '%'
              dataInfo.data[i].commonCountString = ' 中评' + 0 + '个，' + '中评率' + 0 + '%'
              dataInfo.data[i].badCountString = ' 差评' + 0 + '个，' + '差评率' + 0 + '%'
            } else {
              dataInfo.data[i].goodCountString = ' 好评' + dataInfo.data[i].goodCount + '个，' + '好评率' + (dataInfo.data[i].goodCount / count * 100).toFixed(2) + '%'
              dataInfo.data[i].commonCountString = ' 中评' + dataInfo.data[i].commonCount + '个，' + '中评率' + (dataInfo.data[i].commonCount / count * 100).toFixed(2) + '%'
              dataInfo.data[i].badCountString = ' 差评' + dataInfo.data[i].badCount + '个，' + '差评率' + (dataInfo.data[i].badCount / count * 100).toFixed(2) + '%'
            }
          }
          _this.data = dataInfo.data
          _this.totalCount = dataInfo.recordsTotal
        }
      }
      DataMonitorModel.findChannelDataList(this, params, listener)
    }
  }
}
</script>
